import { Enumerable, instanceOf, Kb3dModel } from '../decorators';
import { defaults } from '../default-values';
import { eViewpointProjection, eViewpointTargetMode, eViewpointType } from '../enums';
import { IViewpointNode } from '../kb3d-models';
import { Kb3dObject } from '../kb3d-object';
import { KbVector } from '../primitives';
import { Token } from '../token';

@Kb3dModel<ViewpointNode>({
    token: Token.ViewpointNode,
    onSerializing: (node, o) => {
        // remove any target properties not relevant to the target mode
        if (node.targetMode === eViewpointTargetMode.rotation) {
            delete o.targetPoint;
            delete node.targetMeshId;
        } else if (node.targetMode === eViewpointTargetMode.point) {
            delete o.rotation;
            delete node.targetMeshId;
        } else if (node.targetMode === eViewpointTargetMode.mesh) {
            delete o.targetPoint;
            delete o.rotation;
        }
        return true;
    },
    validate: (n, v) => {
        if (n.changes.hasAny('targetMode', 'targetMeshId')) {
            const exp =
                n.targetMode != eViewpointTargetMode.mesh ||
                (n.targetMeshId != null && n._manager?.getById(n.targetMeshId) != null);
            v.assert(n, 'targetMeshId', exp, 'Target mesh required');
        }
    },
})
export class ViewpointNode extends Kb3dObject implements IViewpointNode {
    constructor() {
        super();

        this.type = eViewpointType.orbit;
        this.targetMode = eViewpointTargetMode.point;
        this.position = KbVector.Zero();
        this.rotation = KbVector.Zero();
        this.targetPoint = KbVector.Zero();
        this.fov = defaults.ViewpointNode.fov;
        this.projection = eViewpointProjection.perspective;
    }

    private _type?: eViewpointType;
    @Enumerable()
    public get type() {
        return this._type;
    }
    public set type(newType) {
        this._type = newType;
        switch (newType) {
            case eViewpointType.firstPerson:
                this.targetMode = eViewpointTargetMode.rotation;
                this.projection = eViewpointProjection.perspective;
                break;
        }
    }
    targetMode: eViewpointTargetMode;
    position: KbVector;
    rotation: KbVector;
    targetPoint: KbVector;
    targetMeshId: string | undefined;
    orbitAxis: KbVector;
    fov: number;
    projection: eViewpointProjection;
    minTargetDistance: number;
    maxTargetDistance: number;

    offsetX = 0; // For panning
    offsetY = 0;

    allowOrbit = true;
    allowPan = true;
    allowZoom = true;
    limitMinimumTargetDistance = false;
    limitLatOrbit = false;
    limitMinLatitude: number;
    limitMaxLatitude: number;
    limitLngOrbit = false;
    limitMinLongitude: number;
    limitMaxLongitude: number;
}

export function isViewpointNode(node: Kb3dObject): node is ViewpointNode {
    return instanceOf<ViewpointNode>(node, Token.ViewpointNode);
}
